export default __webpack_public_path__ + "static/media/Unlimited Morph Hyperborean Warrior.f6530d74.jpg";